import { render, staticRenderFns } from "./AdminManagerForm.vue?vue&type=template&id=222d1352&scoped=true&"
import script from "./AdminManagerForm.vue?vue&type=script&lang=js&"
export * from "./AdminManagerForm.vue?vue&type=script&lang=js&"
import style0 from "./AdminManagerForm.vue?vue&type=style&index=0&id=222d1352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222d1352",
  null
  
)

export default component.exports